export default [
  {
    path: '/admin/event-logs',
    name: 'EventLogs',
    component: () => import('@/views/Admin/Event_logs/Index.vue'),
    meta: {
      pageTitle: 'Sys Aktiviteleri',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'ADMIN_EVENT_LOGS',
      action: 'read',
    },
  },
  {
    path: '/admin/event-logs/view/:id',
    name: 'EventLogEdit',
    component: () => import('@/views/Admin/Event_logs/View.vue'),
    meta: {
      pageTitle: 'Sys Aktiviteleri',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/admin/event-logs',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_EVENT_LOGS_VIEW',
      action: 'read',
    },
  },
]
